
const Menu = [
    {
        path: '/admin/banners/home', icon: 'fa fa-image', title: '배너관리',
        children: [
            { path: '/admin/banners/home/main', title: '메인배너' },
            { path: '/admin/banners/home/side', title: '사이드배너' }
        ]
    },
    {
        path: '/admin/boards/activity', icon: 'fa fa-child', title: '교육활동',
        children: [
            { path: '/admin/boards/activity/visit', title: '교육소식' },
            //{ path: '/admin/boards/activity/learn', title: '더배움' }
        ]
    },
    {
        path: '/admin/boards/cinema', icon: 'fa fa-video', title: '동물영화제',
        children: [
            { path: '/admin/boards/cinema/article', title: '영화제소식' },
            { path: '/admin/boards/cinema/scene', title: '현장스케치' }
        ]
    },
    {
        path: '/admin/boards/library', icon: 'fa fa-book', title: '킁킁도서관',
        children: [
            { path: '/admin/boards/library/news', title: '도서관소식' },
            { path: '/admin/books/library/search', title: '자료검색' },
            //{ path: '/admin/boards/library/day', title: '사서냥이의 하루' }
        ]
    },
    {
        //path: '/admin/boards/home/resource', icon: 'fa fa-folder', title: '자료실',
        path: '/admin/boards/cinema', icon: 'fa fa-folder', title: '자료실',
        children: [
            { path: '/admin/boards/report/newsletter', title: '뉴스레터' },
            { path: '/admin/boards/report/sniffleader', title: '킁킁리더' },
            { path: '/admin/boards/report/resource', title: '교육자료' }
        ]
    },

]

export default Menu;



// WEBPACK FOOTER //
// ./src/components/admin/sidebar/menu.js